import React, { useState } from 'react';
import DashboardSummary from './DashboardSummary';
import Students from './Students';
import TeacherDashboard from './teacher/TeacherDashboard';
import ParentDashboard from './parent/ParentDashboard';
import { Button, Card } from './ui';
import { hasAnyRole } from '../utils/roles';
import portalStyles from './portal/Portal.module.css';

const SCHOOL_SUMMARY_ROLES = ['administrator', 'principal'];
const TEACHING_ROLES = ['teacher', 'head_of_academics'];

function Dashboard({ token, user }) {
  const [activeTab, setActiveTab] = useState('overview');
  const canViewSchoolSummary = hasAnyRole(user, SCHOOL_SUMMARY_ROLES);

  if (!canViewSchoolSummary) {
    const isTeaching = hasAnyRole(user, TEACHING_ROLES);
    const isParent = hasAnyRole(user, ['parent']);

    // Someone can be both (a teacher whose own children attend the school),
    // in which case they get both portals, one after the other.
    if (isTeaching || isParent) {
      return (
        <div className={portalStyles.stack}>
          {isTeaching && <TeacherDashboard token={token} user={user} />}
          {isParent && <ParentDashboard token={token} user={user} />}
        </div>
      );
    }

    return (
      <Card>
        <h2 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '0.5rem' }}>
          Welcome, {user?.full_name || 'there'}
        </h2>
        <p style={{ color: 'var(--color-text-secondary)' }}>
          You're signed in as {(user?.all_roles || [user?.role]).filter(Boolean).join(' & ')}. Use the navigation above to access the areas available to your account.
        </p>
      </Card>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <Button
          variant={activeTab === 'overview' ? 'primary' : 'secondary'}
          size="sm"
          onClick={() => setActiveTab('overview')}
        >
          Overview
        </Button>
        <Button
          variant={activeTab === 'students' ? 'primary' : 'secondary'}
          size="sm"
          onClick={() => setActiveTab('students')}
        >
          Students List
        </Button>
      </div>

      {activeTab === 'overview' && <DashboardSummary token={token} />}
      {activeTab === 'students' && <Students token={token} />}
    </div>
  );
}

export default Dashboard;
